/** @format */

import React, { useEffect, useState } from "react";
import { Table, Tooltip, Select, message } from "antd";
import { useNavigate } from "react-router-dom";
import { GetAllQuote, UpdateQuoteStatus } from "../../services/Api/QuoteApi";
import moment from "moment";
import { Box } from "@material-ui/core";
import { InputText } from "primereact/inputtext";
const { Option } = Select;

const QuoteList = () => {
	const navigate = useNavigate();
	const [pageSize, setPageSize] = useState(50);
	const [quoteData, setQuoteData] = useState([]);
	const [filteredData, setFilteredData] = useState([]);
	const [loading, setLoading] = useState(false);

	// Get all quotes
	const getData = async () => {
		try {
			setLoading(true);
			const result = await GetAllQuote(localStorage.getItem("adminToken"));
			setQuoteData(result.data.data);
			setFilteredData(result.data.data);
			console.log("Quotes Data: ", result.data.data);
		} catch (e) {
			console.log(e);
			if (e.response && e.response.status === 401) {
				navigate("/error401");
				console.log("You do not have access to this page.");
			} else {
				console.log("Error loading data. Please try again later.");
			}
		} finally {
			setLoading(false);
		}
	};

	useEffect(() => {
		getData();
	}, []);

	// Handle status change
	const handleStatusChange = async (value, record) => {
		const updatedStatus = value;

		// Prevent changing status from "resolved" to "pending"
		if (record.quote_status === "RESOLVED" && updatedStatus === "PENDING") {
			message.error("Cannot change status from Resolved to Pending");
			return;
		}

		try {
			// Call the API to update the status
			await UpdateQuoteStatus(record.id, { quote_status: updatedStatus });
			message.success(`Status updated to ${updatedStatus}`);

			// Optimistically update the UI by changing the status locally
			const updatedQuotes = quoteData.map((quote) =>
				quote.id === record.id
					? { ...quote, quote_status: updatedStatus }
					: quote
			);
			setQuoteData(updatedQuotes);
		} catch (error) {
			message.error("Failed to update the status. Please try again.");
			console.log(error);
		}
	};

	// Helper function to style the status text
	const renderStatus = (status) => {
		const color = status === "RESOLVED" ? "green" : "red";
		return (
			<span style={{ color }}>
				{status.charAt(0).toUpperCase() + status.slice(1)}
			</span>
		);
	};

	const onSearch = (searchField) => {
		const searchTerm = searchField.toLowerCase();
		const filteredList = quoteData.filter((item) => {
			// Match with name, message, or service name
			return (
				item.name.toLowerCase().includes(searchTerm) ||
				item.messages.toLowerCase().includes(searchTerm) ||
				(item.service_quote?.name?.toLowerCase() || "").includes(searchTerm) // Handle if service_quote or name is undefined
			);
		});
		setFilteredData(filteredList); // Set the filtered data to state
	};

	const columns = [
		{
			title: "Sr. No", // Serial number column
			dataIndex: "srNo",
			key: "srNo",
			render: (text, record, index) => index + 1, // Render serial numbers starting from 1
			width: "5%",
		},
		{
			title: "Name",
			dataIndex: "name",
			key: "name",
			width: "10%",
		},
		{
			title: "Email",
			dataIndex: "email",
			key: "email",
			width: "10%",
		},
		{
			title: "Number",
			dataIndex: "contact_number",
			key: "contact_number",
			width: "10%",
		},
		{
			title: "Service",
			dataIndex: ["service_quote", "name"],
			key: "contact_number",
			width: "10%",
		},
		{
			title: "Subject",
			dataIndex: "subject",
			key: "subject",
			width: "15%",
		},
		{
			title: "Message",
			dataIndex: "messages",
			key: "messages",
			width: "15%",
			render: (text) => (
				<Tooltip title={text}>
					{text.length > 50 ? `${text.substring(0, 50)}...` : text}
				</Tooltip>
			),
		},
		{
			title: "Status",
			dataIndex: "quote_status",
			key: "quote_status",
			width: "10%",
			render: (text, record) => (
				<Select
					value={text}
					onChange={(value) => handleStatusChange(value, record)}
					style={{ width: "100%" }}
				>
					<Option value="PENDING">
						<span style={{ color: "red" }}>PENDING</span>
					</Option>
					<Option value="RESOLVED">
						<span style={{ color: "green" }}>RESOLVED</span>
					</Option>
				</Select>
			),
		},
		{
			title: "Raised At",
			dataIndex: "created_at",
			key: "created_at",
			render: (date) => moment(date).format("YYYY-MM-DD HH:mm:ss"),
			width: "10%",
		},
	];

	return (
		<div>
			<Box display="flex" justifyContent="space-between" alignItems="center">
				<div>
					<h3 className="page-title">Quote List</h3>
					<p className="page-sub-title">View all Quote List</p>
				</div>
				<Box>
					<span className="p-input-icon-left">
						<i className="pi pi-search" />
						<InputText
							type="search"
							onChange={(e) => {
								onSearch(e.target.value);
							}}
							placeholder="Search..."
						/>
					</span>
				</Box>
			</Box>
			{loading ? (
				<p>Loading...</p>
			) : (
				<Table
					columns={columns}
					dataSource={filteredData}
					pagination={{
						pageSize: pageSize,
						showSizeChanger: true,
						pageSizeOptions: [50, 75, 100],
						onShowSizeChange: (current, size) => setPageSize(size),
					}}
					rowKey={(record) => record.id} // Use the `id` as a unique key for each row
				/>
			)}
		</div>
	);
};

export default QuoteList;
